import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ICountriesApiClient } from './i-countries-api.client';
import { IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { IStateResponse } from '../../states/dtos';
import { statesData } from '../../states/data';
import { geographicalZonesData } from '../../geographical-zones/data';
import { IGeographicalZoneResponse } from '../../geographical-zones/dtos';
import { ICountriesResponse, ICreateCountryRequest, IUpdateCountriesReqeust } from '../dtos';
import { countriesData } from '../data';


@Injectable({
  providedIn: 'root'
})
export class CountriesInMemoryApiClient implements ICountriesApiClient {
  constructor(protected http: HttpClient) {}

  get(
      paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICountriesResponse>> {
    return of(countriesData.countriesResponse);
  }

  getById(id: string): Observable<ICountriesResponse> {
    return of(countriesData.countryResponse);
  }

  create(request: ICreateCountryRequest): Observable<ICountriesResponse> {
    return of(countriesData.countryResponse);
  }

  update(id: string, request: IUpdateCountriesReqeust): Observable<void> {
    return of();
  }

  getStates(
    countryId: string,
      paginationParameters?: ISoftDeletablePaginationParameters
    ): Observable<IPaginationResponse<IStateResponse>> {
      return of(statesData.statesResponse);
    }

    getGeographicalZones(
      countryId: string,
      paginationParameters?: ISoftDeletablePaginationParameters
    ): Observable<IPaginationResponse<IGeographicalZoneResponse>> {
      return of(geographicalZonesData.geographicalZonesResponse);
    }
}
